import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "@safers/api";
import { useAuthStore } from "@safers/auth";
import { clearLastVisit } from "@/lib/lastVisit";
import { LOGIN_PATH } from "@/routes/paths";

export function useSignOut(): () => Promise<void> {
  const navigate = useNavigate();

  return async () => {
    const username = useAuthStore.getState().user?.username ?? null;
    await logout().catch(() => {});
    clearLastVisit(username);
    useAuthStore.getState().reset();
    navigate(LOGIN_PATH, { replace: true });
  };
}

/**
 * 본인 비밀번호를 바꾼 뒤 다시 로그인하게 한다. 서버는 이때 지금 세션까지 모두 지우므로,
 * 그대로 두면 남은 액세스 토큰이 끝나는 순간(최대 1시간 뒤) 작업 중에 로그인으로 넘어간다.
 * 같은 사람이 곧 다시 들어오니 마지막 방문은 지우지 않고, 보던 화면으로 돌아오게 한다.
 */
export function usePasswordChangedSignOut(): () => Promise<void> {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  return async () => {
    await logout().catch(() => {});
    useAuthStore.getState().reset();
    const params = new URLSearchParams({
      reason: "password-changed",
      returnUrl: pathname + search,
    });
    navigate(`${LOGIN_PATH}?${params}`, { replace: true });
  };
}
